import "../../App.css"
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faChevronDown, faChevronUp} from "@fortawesome/free-solid-svg-icons";
import * as React from "react";

interface Props {
  displayList: boolean,
  count: number | undefined,
}

function DisplayListControl(props: Props) {
  return (
      <div className={"float-right"}>
        {props.count != undefined && <div className={"tag bg-blue font-md"}>{props.count}</div>}
        {(props.count == undefined || (props.count != undefined && props.count > 0)) && <div className={"ms-2 d-inline-block"}>
          {!props.displayList && <FontAwesomeIcon icon={faChevronDown}/>}
          {props.displayList && <FontAwesomeIcon icon={faChevronUp}/>}
        </div>}
      </div>
  )
}

export default DisplayListControl;